<template>
  <v-tooltip
    bottom
    :open-delay="openDelay"
  >
    <template #activator="{ on, attrs }">
      <!-- Wrapper enables tooltip hover even when <v-btn> is disabled -->
      <span
        class="d-inline-block"
        v-bind="attrs"
        v-on="on"
      >
        <v-btn
          :class="buttonClass"
          :icon="icon"
          v-bind="$attrs"
          @click="onClick"
        >
          <slot />
        </v-btn>
      </span>
    </template>
    <span>{{ tooltipTitle }}</span>
  </v-tooltip>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { TranslateResult } from 'vue-i18n';

const emit = defineEmits<{(e: 'click', evt: MouseEvent): void}>();

const props = defineProps({
  tooltipTitle: { type: String as PropType<string | TranslateResult>, required: false, default: '' },
  buttonClass: { type: String, required: false, default: '' },
  icon: { type: Boolean, required: false, default: true },
  stopPropagation: { type: Boolean, required: false, default: true },
  openDelay: { type: [Number, String], required: false, default: 1200 },
});

const onClick = (evt: MouseEvent) => {
  if (props.stopPropagation) evt.stopPropagation();
  emit('click', evt);
};
</script>
